export const adsFixer = function () {
  const urlParams = new URLSearchParams(window.location.search);
  const getFrom = urlParams.get("from");

  if (getFrom) {
    localStorage.setItem("from", getFrom);
  }
};
